import { useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import http from "../../../common/http-common";
import * as common from "../../../common/common";
import * as Comp from "../../../common/CommonComponents";

const DeleteTicketCategory = (props) => {

	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
	const hideModal = () => {
		props.onHide();
	};

	const deleteBtnOnClick = () => {
		DeleteTicketCategory(props.editData);
	};

    const DeleteTicketCategory = (_data) => {
		let functionName = "";

		try {
			functionName = props.page + DeleteTicketCategory.name;

			props.onLoading(true, "Deleting ticket category, please wait...");
			props.onHide();

			const data = {
				TICKET_CATEGORY_ID: _data.TICKET_CATEGORY_ID,
				TICKET_CATEGORY_NAME: _data.TICKET_CATEGORY_NAME,
			    UPDATE_ID: userId,
			    FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
			};

			http
				.put("api/TicketCategory/DeleteTicketCategory", data, { timeout: 5000 })
				.then(() => {
					toast.success("Ticket category is successfully deleted.");
					props.onReload();
				})
				.catch((err) => {
					toast.error("Failed to delete ticket category. Please try again.");
					common.c_LogWebError(props.page, functionName, err);
				})
				.finally(() => {
					props.onLoading(false, "Loading...");
				});
		} catch (err) {
			props.onLoading(false, "Loading...");
			toast.error("Failed to delete ticket category. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	};
	//#endregion

	const message = (
		<>
			Confirm to delete?
			<br />
			Ticket Category :
			{<b> {props.editData !== null && props.editData.TICKET_CATEGORY_NAME}</b>}
		</>
	);

	return (
		<>
			<Comp.ConfirmModal
				show={props.showHide}
				onHide={hideModal}
				onConfirm={deleteBtnOnClick}
				delete
			>
				{message}
			</Comp.ConfirmModal>
		</>
	);

};

export default DeleteTicketCategory;